/**
 * useDecisionGate (CHAP-249) — fetch the gate + edit a criterion.
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiGet, apiPatch } from '../lib/api.js';
import type { DecisionGateOutcome, DecisionGateResponse, DecisionGateState } from '../../shared/types.js';

export function useDecisionGate(slug: string) {
  return useQuery<DecisionGateResponse, Error>({
    queryKey: ['decision-gate', slug],
    queryFn: () => apiGet<DecisionGateResponse>(`/api/c/${slug}/decision-gate`),
    enabled: !!slug,
  });
}

export function useUpdateCriterion(slug: string) {
  const qc = useQueryClient();
  return useMutation<unknown, Error, { id: string; state?: DecisionGateState; notes?: string | null }>({
    mutationFn: ({ id, ...body }) => apiPatch(`/api/c/${slug}/decision-gate/criteria/${id}`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['decision-gate', slug] }),
  });
}

/** CHAP-249 archive AC — record the decision outcome (team/admin only). */
export function useRecordDecision(slug: string) {
  const qc = useQueryClient();
  return useMutation<unknown, Error, { decidedOutcome: DecisionGateOutcome }>({
    mutationFn: (body) => apiPatch(`/api/c/${slug}/decision-gate`, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['decision-gate', slug] }),
  });
}
